var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import { UrlHelper } from "../../helper/UrlWrapper";
import GlobalVue from "../../globalVue";
import { Loading } from 'element-ui';
import SourceCodeService from '../../api/SourceCodeService';
import Header from './header.vue';
import Table from './table.vue';
import Preview from './component/sourceCodePreview.vue';
import BindGoods from '../client/BindGoods.vue';
var PurchaseList = (function (_super) {
    __extends(PurchaseList, _super);
    function PurchaseList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            organ_id: '',
            depot_id: '',
        };
        _this.isDelivery = false;
        _this.searchParams = null;
        _this.listData = [];
        _this.total = 0;
        _this.previewType = false;
        _this.isShowUnboundTip = false;
        _this.un_bind_goods_codes = [];
        return _this;
    }
    PurchaseList.prototype.created = function () {
        this.headerData = {
            orderSources: this.orderSources,
            orderCustomers: this.orderCustomers,
            orderIds: this.orderIds,
        };
        this.service = SourceCodeService.getInstance();
        this.sourceCodeType = sessionStorage.getItem("sourceCodeType");
    };
    PurchaseList.prototype.search = function (searchParams) {
        this.searchParams = searchParams || this.searchParams;
        this.status = this.searchParams.dimension;
        console.log(this.searchParams);
        this.$refs.pagination.clear();
        this.getOrderList();
    };
    PurchaseList.prototype.pageChange = function (pager) {
        this.getOrderList();
    };
    PurchaseList.prototype.getOrderList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var params = {};
        Object.assign(params, pager, this.searchParams);
        var loadingInstance = Loading.service({ fullscreen: true });
        var tempType = "";
        if (this.sourceCodeType == "delivery") {
            tempType = "getSourceCodeDelivery";
        }
        else if (this.sourceCodeType == "entrust") {
            tempType = "getSourceCodeEntrustDelivery";
        }
        else if (this.sourceCodeType == "purchase") {
            tempType = "getSourceCode";
        }
        this.service[tempType](params).then(function (res) {
            var data = res.data.data;
            _this.listData = data;
            _this.listData.forEach(function (item, index) {
                item["printNum"] = _this.searchParams.printNum;
                item["index"] = index;
            });
            _this.total = res.data.total;
            if (_this.sourceCodeType == "purchase") {
                var codes = res.data.un_bind_goods_codes;
                if (codes && codes.length > 0) {
                    _this.isShowUnboundTip = true;
                    _this.un_bind_goods_codes = codes;
                }
            }
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchaseList.prototype.previewSourceCode = function (row) {
        var _this = this;
        var params = {
            order_ids: this.orderIds,
            goods_ids: row.goods_id
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        var tempType = "";
        if (this.sourceCodeType == "delivery") {
            tempType = "previewSourceCodeDelivery";
        }
        else if (this.sourceCodeType == "entrust") {
            tempType = "previewSourceCodeEntrustDelivery";
        }
        else if (this.sourceCodeType == "purchase") {
            tempType = "previewSourceCode";
        }
        this.service[tempType](params).then(function (res) {
            if (res.data.data && Object.keys(res.data.data).length !== 0) {
                _this.sourceCodeData = res.data.data;
                _this.previewType = true;
                loadingInstance.close();
            }
            else {
                loadingInstance.close();
                _this.$message.error("暂无数据");
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchaseList.prototype.dialogClose = function () {
        this.previewType = false;
    };
    PurchaseList.prototype.closeTab = function () {
        var closeBtnArr = $(".navTabsCloseBtn").prev();
        for (var i = 0; i < closeBtnArr.length; i++) {
            if ($(closeBtnArr[i])[0].innerText == "溯源码打印") {
                console.log($(closeBtnArr[i]).next());
                $(closeBtnArr[i]).next().click();
            }
        }
    };
    PurchaseList.prototype.print = function () {
        var _this = this;
        console.log("打码", this.listData);
        var goodsIdArr = [];
        this.listData.forEach(function (item) {
            goodsIdArr.push(item.goods_id);
        });
        var params = {
            order_ids: this.orderIds,
            goods_ids: goodsIdArr.join(",")
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        var tempType = "";
        if (this.sourceCodeType == "delivery") {
            tempType = "previewSourceCodeDelivery";
        }
        else if (this.sourceCodeType == "entrust") {
            tempType = "previewSourceCodeEntrustDelivery";
        }
        else if (this.sourceCodeType == "purchase") {
            tempType = "previewSourceCode";
        }
        this.service[tempType](params).then(function (res) {
            _this.sourceCodePrintData = res.data.data;
            loadingInstance.close();
            if (_this.sourceCodePrintData && Object.keys(_this.sourceCodePrintData).length !== 0) {
                _this.listData.forEach(function (item) {
                    _this.sourceCodePrintData[item.goods_id]["printNum"] = item.printNum;
                });
                sessionStorage.setItem("sourceCodePrintData", JSON.stringify(_this.sourceCodePrintData));
                var url = "./static/js/print/sourceCodePrint.html";
                url = UrlHelper.addParam(url, 'token', _this.user.token);
                UrlHelper.windowOpenIntercept(url);
            }
            else {
                _this.$message.error("暂无数据！");
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchaseList.prototype.goBound = function () {
        var business_id = this.business_id.toString();
        var supplier_to_business_id = this.supplier_to_business_id.toString();
        var goodCodes = this.un_bind_goods_codes.join(' ');
        GlobalVue.$emit("addTab", {
            component: BindGoods,
            title: '绑定货品',
            showExist: true,
            name: 'bindGoods',
            cprops: {
                clientIds: business_id,
                business_id: business_id,
                supplierToBusinessIds: supplier_to_business_id,
                supplier_to_business_id: supplier_to_business_id,
                good_code: goodCodes
            }
        });
    };
    PurchaseList = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            components: {
                'cusHeader': Header,
                'listData': Table,
                'preview': Preview
            },
        })
    ], PurchaseList);
    return PurchaseList;
}(Vue));
export default PurchaseList;
